import { EditInlineDialogProps } from "../../../../types";
import DeleteLicense from "../../../shared/DeleteLicense";

const DeleteDesktopLicense = ({
    data,
    isOpen,
    close
}: EditInlineDialogProps) => {
    return (
        <DeleteLicense
            data={data}
            isOpen={isOpen}
            close={close}
            isDesktopLicense
        />
    );
};

export default DeleteDesktopLicense;
